const $ = jQuery.noConflict();

class FixedContent {
    constructor(contentBoxes, header, pageWrapper) {
        this.contentBoxes = $(contentBoxes);
        this.header = $(header);
        this.pageWrapper = $(pageWrapper);
    }
    init() {
        this.fakeHeight();
        this.checkScroll();
    }
    fakeHeight() {
        this.contentBoxes.each((index, element) => {
            $(element).after('<div style="width: 100%;"></div>');
        });
    }

    setFixed(element) {
        const headerHeight = this.header.outerHeight();

        $(element).css({
            position: 'fixed',
            top: headerHeight + 'px',
            left: 0,
            right: 0,
            bottom: 'unset'
        });
        $(element).next().css({
            height: $(element).outerHeight()
        });
    }

    unsetFixed(element) {
        $(element).css({
            position: '',
            top: '',
            left: '',
            right: '',
            bottom: ''
        });
        $(element).next().css({
            height: ''
        });
    }

    checkScroll() {
        const headerHeight = this.header.outerHeight();
        const pageWrapperOffset = $('#page-wrapper').offset().top - $(window).scrollTop() - headerHeight;

        this.contentBoxes.each((index, element) => {
            const offset = $(element).offset().top - $(window).scrollTop();
            if(offset <= headerHeight && pageWrapperOffset <= 0) {
                this.setFixed(element);
            } else {
                this.unsetFixed(element);
            }
        });

    }
}

export default new FixedContent('.js-fixed-content', '.main-header', '#page-wrapper');
